export const ERROR_MESSAGES: { [key: string]: (...args: any) => string } = {
  required: (controlName: string) => `${controlName} is required`,
  minlength: (controlName: string, maxRequirement: any) =>
    `${controlName} must be at least ${maxRequirement.requiredLength} characters long`,
  maxlength: (controlName: string, minRequirement: any) =>
    `${controlName} must be no more than ${minRequirement.requiredLength} characters long`,
  email: () => 'Please enter a valid email address',
  passwordMismatch: () => 'Passwords do not match',
  pattern: () => 'Password must contain, at least 8 characters and one uppercase, lowercase, number and special character. Ex. Password1!',
  emailExists: () => 'Email already exists',
  projectExists: () => 'Project name already exists',
  scheduleExistsWithinProject: () => 'Schedule name already exists within Project',
  productTypeDoesntExistsWithinSchedule: () =>"Active line item(s) for selected Product type don't exist within selected schedule",
  incorrectPassword: () => 'Incorrect password',
  notEqualTo: (controlName: string) => `${controlName} cannot be equal to password example: Password1!`,
  requiredIf: (controlName: string) => `${controlName} is required`,
};
